// extracted by mini-css-extract-plugin
export default {"competitorAnalysis":"CompetitorAnalysis_competitorAnalysis__TxS2I","competitorAnalysisImage":"CompetitorAnalysis_competitorAnalysisImage__hOPa3"};